export default __webpack_public_path__ + "img/38.e06207.png";